import { Space } from "antd"
import { Title } from "ui/Typography"
import { useTranslation } from "react-i18next"
import BookingDetailsHeader from "./Header"
import BookingDetailsBody from "./Body"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import useLoaderWatchers from "modules/loader-watchers/hooks/useLoaderWatchers"
import styles from "./index.module.css"

const BookingDetails = ({ isShowTitle = true }) => {
  const { t } = useTranslation()
  const { data } = useSelector((store) => store?.bookings?.clientBookingDetails) || {}
  useLoaderWatchers({ watchers: ["bookings.clientBookingDetails"] })

  return (
    <Space direction="vertical" size={32} className="w-full">
      {isShowTitle && <Title level={3}>{t("client.booking_details")}</Title>}
      <BookingDetailsHeader booking={data} className={`${isShowTitle ? "" : styles.bookingdetails}`} />
      <BookingDetailsBody booking={data} />
    </Space>
  )
}

BookingDetails.propTypes = {
  isShowTitle: PropTypes.bool
}

export default BookingDetails
